var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(-966 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5340",
    "data-name": "Group 5340"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 128,
    height: 128,
    transform: "translate(966 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "copy-2",
    "data-name": "copy",
    transform: "translate(931.094 529.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5050",
    "data-name": "Group 5050",
    transform: "translate(48.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M116.927,85.4H58.573a9.929,9.929,0,0,0-9.923,9.923v83.726a9.929,9.929,0,0,0,9.923,9.923h58.354a9.929,9.929,0,0,0,9.923-9.923V95.323A9.962,9.962,0,0,0,116.927,85.4Zm2.956,93.623a2.984,2.984,0,0,1-2.982,2.982H58.547a2.984,2.984,0,0,1-2.982-2.982v-83.7a2.984,2.984,0,0,1,2.982-2.982H116.9a2.984,2.984,0,0,1,2.982,2.982Z",
    transform: "translate(-48.65 -63.447)",
    fill: "#314155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M203.727,0H145.373a9.929,9.929,0,0,0-9.923,9.923,3.47,3.47,0,1,0,6.941,0,2.984,2.984,0,0,1,2.982-2.982h58.354a2.984,2.984,0,0,1,2.982,2.982V93.649a2.984,2.984,0,0,1-2.982,2.982,3.47,3.47,0,0,0,0,6.941,9.929,9.929,0,0,0,9.923-9.923V9.923A9.929,9.929,0,0,0,203.727,0Z",
    transform: "translate(-113.137)",
    fill: "#314155"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.21c144c3.svg";
export { ForwardRef as ReactComponent };